export interface Hersteller {
  name: string;
  logo: string;
  website: string;
  text: string;
  /** Produkt-Kategorie für Label unter dem Logo (z. B. "Wallboxen", "Stromspeicher"). */
  category: string;
  /** Optionaler Zusatz, 1-2 Worte (z. B. "Premium-Module", "Deutsche Qualität"). */
  tagline?: string;
}

export const HERSTELLER: Hersteller[] = [
  {
    name: "IBC Solar",
    logo: "/images/IBC_Solar-1.webp",
    website: "https://www.ibc-solar.de/",
    category: "Komplettsystem",
    tagline: "Deutsche Qualität · seit 1982",
    text:
      "Das oberfränkische Unternehmen IBC Solar gehört zu den Pionieren der Branche und entwickelt seit 1982 Produkte im Bereich Photovoltaik. Unterkonstruktion, Module, Wechselrichter und Speicher aus einer Hand – mit hauseigenem Energiemanagement und eigenem dynamischen Stromtarif. All das von einem deutschen Garantiegeber.",
  },
  {
    name: "Enphase",
    logo: "/images/enphase.webp",
    website: "https://enphase.com/de-de",
    category: "Mikrowechselrichter",
    tagline: "25 Jahre Garantie",
    text:
      "Der US-amerikanische Hersteller Enphase bietet mit seinen Mikrowechselrichtern und einer Produktgarantie von 25 Jahren eine absolute Premium-Lösung. Ein besonderer Vorteil ist die hohe Flexibilität, mit der kleinteilige oder von Verschattung betroffene Flächen optimal genutzt werden können.",
  },
  {
    name: "BYD",
    logo: "/images/BYD.webp",
    website: "https://bydbatterybox.com/",
    category: "Stromspeicher",
    tagline: "Battery-Box · seit 1995",
    text:
      "Seit 1995 produziert das chinesische Unternehmen BYD Stromspeicher. Die Speicher von BYD sind bekannt für höchste Qualität, bewähren sich seit vielen Jahren und sind dank der Kompatibilität zu vielen Wechselrichter-Herstellern flexibel einsetzbar.",
  },
  {
    name: "AIKO",
    logo: "/images/AIKO.webp",
    website: "https://aikosolar.com/de/",
    category: "Hochleistungs-Module",
    tagline: "Branchenführende Effizienz",
    text:
      "Aiko ist der Spezialist für Premium-Module mit ultrahoher Effizienz in einem modernen Design. Branchenführende Wirkungsgrade erlauben eine maximale Stromerzeugung pro Modul.",
  },
  {
    name: "KEBA",
    logo: "/images/Keba.webp",
    website: "https://www.keba.com/de/home",
    category: "Wallboxen",
    tagline: "Made in Austria",
    text:
      "KEBA ist ein international tätiges Technologieunternehmen mit Hauptsitz in Österreich. Das Portfolio an hochwertigen Wallboxen deckt vom Einfamilienhaus bis zum gewerblichen Fuhrpark alles ab.",
  },
  {
    name: "Solarmanager",
    logo: "/images/Solarmanager.webp",
    website: "https://www.solarmanager.ch/",
    category: "Energiemanagement",
    tagline: "Herstellerunabhängig",
    text:
      "Die Schweizer Firma Solarmanager bietet ein herstellerunabhängiges Energiemanagement. Komponenten verschiedener Hersteller werden intelligent gesteuert und auf maximalen Eigenverbrauch optimiert.",
  },
  {
    name: "Tigo",
    logo: "/images/Tigo.webp",
    website: "https://www.tigoenergy.com/",
    category: "Modul-Optimierer",
    tagline: "Verschattungs-Schutz",
    text:
      "Tigo bietet modulare Optimierer- und Monitoring-Lösungen, mit denen sich der Ertrag jedes einzelnen Moduls überwachen und in verschatteten Bereichen steigern lässt.",
  },
];
